import { DataSourceTable } from 'src/constants/dataSourceTable';
import {
  DataSourceType,
  DataSourceTypeDescription,
  UNKNOWN_DATA_SOURCE_TYPE,
} from 'src/constants/dataSourceTypeDescription';

export type TableMetadataErrorResponse = {
  status?: number;
  errorMessage: string;
} | null;

type BaseDataSource = {
  id: string;
  entityName: string;
  sharable: boolean;
  available: boolean;
  options: null | Record<string, any>;
  tables: null | DataSourceTable[];
  type: DataSourceType;
  tableMetadataErrorResponse: TableMetadataErrorResponse;
};

export type SqlDataSource = BaseDataSource & {
  type: DataSourceType;
  options: Record<string, any> & {
    ['jdbc.url']: string;
  };
};

export type CassandraDataSource = BaseDataSource & {
  type: 'CASSANDRA';
  options:
    | null
    | (Record<string, any> & {
        ['cassandra.contact.point']: string;
      });
};

export type ElasticsearchDataSource = BaseDataSource & {
  type: 'ELASTICSEARCH';
  options:
    | null
    | (Record<string, any> & {
        ['elasticsearch.rest.urls']: string;
      });
};

export type MongoDataSource = BaseDataSource & {
  type: 'MONGODB';
  options:
    | null
    | (Record<string, any> & {
        ['mongodb.uri']: string;
      });
};

export type UnknownDataSource = BaseDataSource & {
  type: typeof UNKNOWN_DATA_SOURCE_TYPE;
};

export type DataSource =
  | SqlDataSource
  | CassandraDataSource
  | ElasticsearchDataSource
  | MongoDataSource
  | UnknownDataSource;

export class DataSourcesState {
  constructor(
    public typeDescriptionByConnectionId: Record<
      string,
      DataSourceTypeDescription
    > = {},
    public dataSourceIds: string[] = [],
    public dataSourcesById: Record<string, DataSource> | null = null,
    public pendingAddDataSource: boolean = false,
    public pendingRefreshDataSources: boolean = false,
    public virtualGraphsById: Record<string, VirtualGraph> = {}
  ) {}
}

export type VirtualGraph = {
  name: string;
  database: string;
  available: boolean;
  dataSource: string;
};

export enum SqlQuotingConvention {
  NATIVE = 'NATIVE',
  ANSI = 'ANSI',
}

export enum VirtualGraphOption {
  SQL_QUOTING_CONVENTION = 'parser.sql.quoting',
  SQL_FUNCTIONS = 'sql.functions',
  PERCENT_ENCODE = 'percent.encode',
}
